// ValidateJS format matching MUST be anchored to start and end of string in order to test
// regexes correctly. https://validatejs.org/#validators-format

const gbzipcodeRE = new RegExp(
  '^([Gg][Ii][Rr] 0[Aa]{2})|' +
  '((([A-Za-z][0-9]{1,2})|' +
  '(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|' +
  '(([A-Za-z][0-9][A-Za-z])|'+
  '([A-Za-z][A-Ha-hJ-Yj-y][0-9]?' +
  '[A-Za-z]))))[ ]{0,1}[0-9][A-Za-z]{2})$'
);

const cazipcodeRE = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
const uszipcodeRE = /^[0-9]{5}(?:-[0-9]{4})?$/;
const intzipcodeRE = /^[\w- ]+$/;

export function zipCodeFormat(countryCode) {
  switch(countryCode) {
    case 'US': return uszipcodeRE;
    case 'CA': return cazipcodeRE;
    case 'GB': return gbzipcodeRE;
    default: return intzipcodeRE;
  }
}

export function zipCodeMaxLength(countryCode) {
  if(countryCode === 'US') { return 5; }
  if(countryCode === 'CA') { return 7; }
  return 10;
}

export function zipCodeMinLength(countryCode) {
  if(countryCode === 'US') { return 5; }
  if(countryCode === 'CA') { return 6; }
  if(countryCode === 'GB') { return 6; }
  return 4;
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/validation/zipCode.js